import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { getQuestionsWithAnswers } from 'funnel/selectors/question';
import QuestionList from 'funnel/components/detail/questions/QuestionList';
import {
  createQuestion,
  updateQuestion,
  moveQuestionUp,
  moveQuestionDown,
  deleteQuestion,
} from 'funnel/actions/question';
import {
  moveAnswerUp,
  moveAnswerDown,
  deleteAnswer,
} from 'funnel/actions/answer';

const mapStateToProps = state => ({
  questions: getQuestionsWithAnswers(state),
});
const mapDispatchToProps = dispatch => ({
  createQuestion: () => dispatch(createQuestion),
  updateQuestion: question => dispatch(updateQuestion(question)),
  moveQuestionUp: question => dispatch(moveQuestionUp(question)),
  moveQuestionDown: question => dispatch(moveQuestionDown(question)),
  deleteQuestion: id => dispatch(deleteQuestion(id)),
  moveAnswerUp: answer => dispatch(moveAnswerUp(answer)),
  moveAnswerDown: answer => dispatch(moveAnswerDown(answer)),
  deleteAnswer: answer => dispatch(deleteAnswer(answer)),
});
const FunnelQuestionsPage = ({
  questions,
  updateQuestion,
  moveQuestionUp,
  moveQuestionDown,
  deleteQuestion,
  moveAnswerUp,
  moveAnswerDown,
  deleteAnswer,
}) => (
  <div>
    <QuestionList
      questions={questions}
      updateQuestion={updateQuestion}
      moveQuestionUp={moveQuestionUp}
      moveQuestionDown={moveQuestionDown}
      deleteQuestion={deleteQuestion}
      moveAnswerUp={moveAnswerUp}
      moveAnswerDown={moveAnswerDown}
      deleteAnswer={deleteAnswer}
    />
  </div>
);

FunnelQuestionsPage.propTypes = {
  questions: PropTypes.array,
  updateQuestion: PropTypes.func.isRequired,
  moveQuestionUp: PropTypes.func.isRequired,
  moveQuestionDown: PropTypes.func.isRequired,
  deleteQuestion: PropTypes.func.isRequired,
  moveAnswerUp: PropTypes.func.isRequired,
  moveAnswerDown: PropTypes.func.isRequired,
  deleteAnswer: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  FunnelQuestionsPage
);



// WEBPACK FOOTER //
// ./src/modules/funnel/pages/FunnelQuestionsPage.js